export default "__VITE_ASSET__DQSTWc8H__"